import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";

function ConfirmRemoveCoach(props) {
  const { t } = useTranslation(["coaching-portal", "common"]);
  return (
    <form
      action={`/dashboard/settings/manage-coaching`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="actionToPerform" value="remove" />
      <Modal width="600px" title={t("confirmRemoveCoach.title")}>
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              {t("confirmRemoveCoach.intro")}{" "}
              <b>{t("confirmRemoveCoach.noLongerAbleTo")}</b>
              <ul>
                <li>{t("confirmRemoveCoach.noCustomPrograms")}</li>
                <li>{t("confirmRemoveCoach.noCalendarAccess")}</li>
                <li>{t("confirmRemoveCoach.noMetricsAccess")}</li>
              </ul>
            </div>
          </div>
        </div>

        <footer className="foot">
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            {t("common:cancel")}
          </a>
          <button data-button-type="primary" type="submit">
            {t("common:remove")}
          </button>
        </footer>
      </Modal>
    </form>
  );
}

export default ConfirmRemoveCoach;
